import { render, staticRenderFns } from "./_editorHerbal.vue?vue&type=template&id=2c0c29dd"
import script from "./_editorHerbal.vue?vue&type=script&lang=js"
export * from "./_editorHerbal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports